<template>
  <div class="content">
    <!-- 筛选查询框 -->
    <el-form :inline="true" class="demo-form-inline" size="mini">
      <el-form-item>
        <el-input
          v-model="userId"
          placeholder="请输入用户id"
          style="width:250px"
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item>
        <el-input
          v-model="phone"
          placeholder="请输入手机号"
          style="width:250px"
          clearable
        ></el-input>
      </el-form-item>
      <!-- <el-form-item label="类型: " style="margin-left:20px">
        <el-select v-model="business" placeholder="请选择" clearable>
          <div v-for="item in businessArr" :key="item.id">
            <el-option :label="item.name" :value="item.id"></el-option>
          </div>
        </el-select>
      </el-form-item> -->
      <el-form-item>
        <el-button type="primary" @click="seletByNameBtn">搜索</el-button>
      </el-form-item>
    </el-form>
    <!-- 商品表格 -->
    <div style="height:80%">
      <el-table
        :data="userArr"
        style="width: 100%"
        height="100%"
        v-loading="loading"
        :header-cell-style="{ background: '#e8effc', color: '#000' }"
      >
        <el-table-column
          type="index"
          label="序号"
          width="50"
          align="center"
        ></el-table-column>
        <el-table-column label="用户id" width="100" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.id }}</span>
          </template>
        </el-table-column>
        <!-- <el-table-column label="姓名" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.name ? scope.row.name : "-" }}</span>
          </template>
        </el-table-column> -->
        <el-table-column label="手机号" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.phone ? scope.row.phone : "-" }}</span>
          </template>
        </el-table-column>
        <el-table-column label="金币" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.money ? scope.row.money : 0 }}</span>
          </template>
        </el-table-column>
        <!-- <el-table-column label="积分" align="center" width="100">
          <template slot-scope="scope">
            <span>{{ scope.row.money }}</span>
          </template>
        </el-table-column> -->
        <!-- <el-table-column label="身份" align="center" width="100">
          <template slot-scope="scope">
            <span>{{
              scope.row.business == 0
                ? "普通用户"
                : scope.row.business == 1
                ? "店长"
                : ""
            }}</span>
          </template>
        </el-table-column> -->
        <!-- <el-table-column label="登陆时间" align="center" width="180">
          <template slot-scope="scope">
            <span>{{ scope.row.createTime }}</span>
          </template>
        </el-table-column> -->
        <!-- <el-table-column label="操作" width="150" align="center">
          <template slot-scope="scope">
            <el-button size="mini" @click="ejectupdataGoods(scope.row)"
              >编辑</el-button
            >
            <el-button size="mini" type="danger" @click="deleteBtn(scope.row.id)">删除</el-button>
          </template>
        </el-table-column> -->
      </el-table>
    </div>
    <!-- 开户表单 -->
    <el-dialog title="修改身份" :visible.sync="dialogFormVisible">
      <el-form :model="form">
        <el-form-item label="身份">
          <el-select v-model="form.business" placeholder="请选择用户身份">
            <div v-for="item in businessArr" :key="item.id">
              <el-option :label="item.name" :value="item.id"></el-option>
            </div>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="sumbmitBtn">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  selectUser,
  updateUserByid,
  deldeteUserByid,
  seleteUserByName,
} from "@/services/user";
export default {
  data() {
    return {
      userArr: [],
      businessArr: [
        { id: 0, name: "普通用户" },
        { id: 1, name: "店长身份" },
      ],
      dialogFormVisible: false,
      form: {},
      loading: true,
      name: "",
      pageCount: "",
      pageSize: 8,
      userId: "",
      phone: "",
      business: "",
    };
  },
  created() {
    // 查询用户登陆数据
    selectUser().then((resp) => {
      console.log(resp);
      this.loading = false;
      this.userArr = resp.data.filter((item) => {
        return item.money > 0;
      });
    });
  },
  methods: {
    seletByNameBtn() {
      // if (this.userId == "" && this.phone == "") {
      //   this.select();
      //   return;
      // }
      // var phone = this.phone;
      // if (phone == "") {
      //   phone = 0;
      // }
      seleteUserByName({
        id: this.userId,
        phone: this.phone,
        business: this.business,
      }).then((res) => {
        this.userArr = res.data.filter((item) => {
          return item.money > 0;
        });
      });
    },
    select() {
      // 查询用户登陆数据
      selectUser().then((resp) => {
        console.log(resp);
        this.loading = false;
        this.userArr = resp.data;
      });
    },
    ejectupdataGoods(row) {
      this.dialogFormVisible = true;
      this.form = row;
    },
    // 修改身份
    sumbmitBtn() {
      console.log(this.form);
      updateUserByid(this.form.id, this.form.business).then((res) => {
        console.log(res);
        this.dialogFormVisible = false;
        this.$message({
          type: "success",
          message: `修改成功!`,
        });
      });
      // this.form.business=this.form.business
    },
    deleteBtn(id) {
      this.$confirm("此操作将永久删除该用户, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          console.log(id);
          deldeteUserByid(id).then((res) => {
            console.log(res);
            this.select();
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
  },
};
</script>

<style>
.content {
  margin: 30px auto;
  /* border:1px solid red; */
  width: 80%;
}
.el-pagination {
  text-align: center;
  margin: 20px;
}
.userNanme:hover {
  cursor: pointer;
}
</style>
